import type {ReactElement} from 'react';
import {useContext} from 'react';
import {Button, IconPlacement, Size, Type} from '@Components/button/button';
import {Icon} from '@Components/icon-v2/icon';
import {IconShape, IconSize, IconType} from '@Components/icon-v2/icon.types';
import {EditorViewport} from '@FormMakerReact/form-maker.types';
import {formMakerContext} from '@FormMakerReact/form-maker.context';
import {SAVE_BUTTON_ICON} from './save-button.types';

/** Manual save for a draft, where autosave is off; it runs the same login/premium gate as every other save trigger. */
export function SaveButton(): ReactElement {
  const {state, actions} = useContext(formMakerContext);
  const label = window.i18next.t('pmwjs_save');

  const onSaveClick = (): void => {
    void actions.save();
  };

  if (state.editorViewport !== EditorViewport.DESKTOP) {
    return (
      <Icon
        icon={SAVE_BUTTON_ICON}
        type={IconType.DARK_GHOST}
        shape={IconShape.SQUARE}
        size={IconSize.SIZE_ICON_20}
        ariaLabel={label}
        isUsedAsButton
        isDisabled={state.isEditorLoading}
        isLoading={state.isSaving}
        onClick={onSaveClick}
      />
    );
  }

  return <Button type={Type.DARK_GHOST} size={Size.SMALL} text={label} icon={SAVE_BUTTON_ICON} iconPlacement={IconPlacement.LEFT} disabled={state.isEditorLoading} isLoading={state.isSaving} onClick={onSaveClick} />;
}
